"use client";

import React from "react";
import { Star, Quote } from "lucide-react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
const testimonials = [{
  id: 1,
  name: "Jameson Miller",
  neighborhood: "1968 Ford Mustang",
  quote: "Dott's Garage is the only place I trust with my vintage Mustang. They treat every bolt with respect, and the Racing Green finish on their own shop reflects the quality they put into their work.",
  rating: 5
}, {
  id: 2,
  name: "Elena Rodriguez",
  neighborhood: "2022 Honda CR-V",
  quote: "A century of expertise really shows. They diagnosed a complex electrical issue that three other shops missed. Honest, professional, and the cleanest garage I've ever stepped into.",
  rating: 5
}, {
  id: 3,
  name: "Arthur Sterling",
  neighborhood: "1954 Chevrolet Bel Air",
  quote: "Finding a mechanic who understands heritage vehicles is rare. Dott's combines old-school craftsmanship with modern precision. They are a true Albany institution.",
  rating: 5
}, {
  id: 4,
  name: "Marcus Thorne",
  neighborhood: "2019 BMW X5",
  quote: "The transparency here is unmatched. No hidden fees, just high-grade engineering and clear communication. It's refreshing to see a local business thrive for over 100 years.",
  rating: 5
}];
export default function NeighborsExperiences() {
  return <section data-section-id="223682" id="voices-of-albany" className="w-full py-24 bg-background text-foreground">
      <div className="container mx-auto px-4 md:px-6">
        <div className="mb-16 flex flex-col items-center text-center">
          <h2 className="text-3xl md:text-4xl font-default font-bold text-primary tracking-tight uppercase mb-4">
            Voices of Albany
          </h2>
          <div className="h-1 w-20 bg-primary rounded-full"></div>
        </div>

        <Carousel opts={{
        align: "center",
        loop: true
      }} className="w-full max-w-4xl mx-auto">
          <CarouselContent className="-ml-8 md:-ml-12">
            {testimonials.map((item, i) => <CarouselItem key={item.id} data-index={i} className="pl-8 md:pl-12 basis-full">
                <div className="relative flex flex-col items-center text-center p-10 md:p-20 rounded-lg bg-card border-2 border-border shadow-lg overflow-hidden h-full">
                  {}
                  <Quote className="absolute top-8 left-8 size-32 text-primary/15 -rotate-12" />
                  
                  <div className="relative z-10 flex flex-col items-center h-full">
                    <div className="flex gap-1.5 mb-8">
                      {[...Array(item.rating)].map((_, starIndex) => <Star key={starIndex} data-index={starIndex} className="size-6 fill-primary text-primary" />)}
                    </div>
                    
                    <p className="text-xl md:text-2xl font-serif italic text-foreground leading-relaxed mb-10 max-w-2xl">
                      "{item.quote}"
                    </p>
                    
                    <div className="mt-auto">
                      <div className="font-default font-bold text-lg text-primary uppercase tracking-tight">
                        {item.name}
                      </div>
                      <div className="text-sm font-medium text-muted-foreground mt-1 font-default">
                        {item.neighborhood}
                      </div>
                    </div>
                  </div>
                </div>
              </CarouselItem>)}
          </CarouselContent>

          <div className="flex justify-center items-center gap-6 mt-12">
            <CarouselPrevious className="static translate-y-0 translate-x-0 size-14 rounded-md border-2 border-primary text-primary bg-white hover:bg-primary hover:text-white transition-colors duration-300" />
            <CarouselNext className="static translate-y-0 translate-x-0 size-14 rounded-md border-2 border-primary text-primary bg-white hover:bg-primary hover:text-white transition-colors duration-300" />
          </div>
        </Carousel>
      </div>
    </section>;
}